import SetConfigItems from './setConfigItems';
import Requests from './requests';

export default {
  SetConfigItems,
  Requests,
};
